
import { Mapper } from "../../../../../core/base";
import {Product } from "../../../../../core/domain";
import { ProductsWebEntity } from "./products-web-entity";

export class ProductsWebRepositoryMapper extends Mapper<ProductsWebEntity, Product> {

  mapFrom(param: ProductsWebEntity): Product {
    return {
      id: param.id,
      name: param.name,
      productId: param.productId,
      productTemplate: param.productTemplate
    };
  }

  mapTo(param: Product): ProductsWebEntity {
    return {
      id: param.id,
      name: param.name,
      productId: param.productId,
      productTemplate: param.productTemplate
    };
  }

}
